import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section aria-labelledby="bonuses-title" className="bg-brand-sand px-4 py-20 md:py-28" data-id="element-20" data-mp="gwx5x4ldv9es">
      <Reveal className="mx-auto max-w-3xl" data-id="element-21" data-mp="vtxlk9qavdww">
        <div className="mb-12 text-center" data-id="element-22" data-mp="vqjmbacxnkto">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand-accent" data-id="element-23" data-mp="qsru0f8dlwoy">
            OFFERTA A TEMPO LIMITATO
          </p>
          <h2 id="bonuses-title" className="mt-4 text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-24" data-mp="14r7zy3yezj61">
            🎁 5 Bonus Esclusivi
          </h2>
          <p className="mt-4 text-brand-gray" data-id="element-25" data-mp="1eiuiymgzumjc">
            Valore totale: <span className="font-bold text-brand-accent" data-id="element-26" data-mp="19jrep48u8kcf">128 €</span> — inclusi gratuitamente nel pack
            di oggi
          </p>
        </div>
        <div className="space-y-3" data-id="element-27" data-mp="1nkbv5tra642r">
          {bonuses.map(({
          image,
          alt,
          title,
          price
        }, index) => <article key={title} className="flex items-center gap-4 rounded-[18px] bg-brand-alt p-3 shadow-sm sm:gap-5 sm:p-4" data-id="element-28" data-mp="1jgdwtl9s4xar" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-primary font-display text-sm font-bold text-white" data-id="element-29" data-mp="3tsou7msbo6rk">
                {index + 1}
              </span>
              <img src={image} alt={alt} className="h-20 w-16 shrink-0 rounded-[10px] bg-brand-cream object-cover shadow-sm sm:h-24 sm:w-[76px]" loading="lazy" data-id="element-30" data-mp="7li86xwx3xyh" />
              <div className="min-w-0 flex-1" data-id="element-31" data-mp="gj10mncw5eke">
                <h3 className="text-sm font-bold leading-snug text-brand-primary md:text-base" data-id="element-32" data-mp="ld56t4ec1ikf">{title}</h3>
                <p className="mt-1.5 flex flex-wrap items-center gap-2 text-xs" data-id="element-33" data-mp="q9vmhqm86c5b">
                  <span className="font-semibold text-brand-gray line-through" data-id="element-34" data-mp="vb2vtu40nje3">{price}</span>
                  <span className="font-extrabold tracking-wide text-brand-teal" data-id="element-35" data-mp="108l55lly40mm">GRATIS</span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}